import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { postTollLiquidation } from '../../../../actions/route/TollLiquidation';
import { TOLL_LIQUIDATION_PATH } from '../../../../config/paths';
import TollLiquidationForm from './TollLiquidationForm';

const NewTollLiquidation = ({ breadcrumbs, dispatchPostTollLiquidation }) => {
  const onSubmit = async (
    formValues,
    selectedItinerary,
    selectedRegisteredBus,
    selectedLiquidatorDriver,
    tollSelection,
    additionalSelection,
    differenceAmount,
    originalPayeeCustomer,
  ) => {
    if (!selectedItinerary) {
      toastr.error('Debe seleccionar un itinerario.');
      return false;
    }

    if (!selectedLiquidatorDriver) {
      toastr.error('Debe seleccionar un conductor liquidador.');
      return false;
    }

    const tollRows =
      tollSelection && tollSelection.selectedRows
        ? tollSelection.selectedRows
        : [];

    const additionalRows =
      additionalSelection && additionalSelection.selectedRows
        ? additionalSelection.selectedRows
        : [];

    const selectedTollRows = tollRows.filter(
      (row) => row.tollAmountApplied === true || row.detractionApplied === true,
    );

    const selectedAdditionalRows = additionalRows.filter(
      (row) => row.applied === true,
    );

    if (selectedTollRows.length === 0 && selectedAdditionalRows.length === 0) {
      toastr.error('Debe seleccionar al menos un peaje o cargo adicional.');
      return false;
    }

    const tollSelectedTotal =
      tollSelection && tollSelection.selectedTotal
        ? Number(tollSelection.selectedTotal)
        : 0;

    const additionalSelectedTotal =
      additionalSelection && additionalSelection.selectedTotal
        ? Number(additionalSelection.selectedTotal)
        : 0;

    const selectedTotal = tollSelectedTotal + additionalSelectedTotal;

    if (selectedTotal <= 0) {
      toastr.error('El total seleccionado debe ser mayor a 0.');
      return false;
    }

    const newFormValues = {
      itineraryId: selectedItinerary.itineraryId,

      totalAmount: formValues.totalAmount || 0.0,

      tollLiquidateAmount: formValues.tollLiquidateAmount || 0.0,

      registeredBusId: selectedRegisteredBus,

      payeeCustomerId: selectedLiquidatorDriver.id,

      tollLiquidationDetailList: tollRows,

      tollLiquidationAdditionalChargeList: additionalRows,

      differenceAmount,

      differenceAmountReasonId: formValues.differenceAmountReasonId
        ? formValues.differenceAmountReasonId.value
        : null,

      observation: formValues.observation,

      originalPayeeCustomerId: originalPayeeCustomer
        ? originalPayeeCustomer.id
        : null,
    };

    const tollLiquidation = await dispatchPostTollLiquidation(newFormValues);

    if (!tollLiquidation) {
      return false;
    }

    toastr.success(
      'Éxito',
      'La liquidación de peaje se registró correctamente.',
    );

    return true;
  };

  const content = <TollLiquidationForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Liquidación de Peaje"
      subtitle="Crear liquidación de peaje"
      content={content}
    />
  );
};

NewTollLiquidation.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchPostTollLiquidation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostTollLiquidation: postTollLiquidation,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Liquidación de Peajes',
      href: TOLL_LIQUIDATION_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewTollLiquidation);
